var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"faq"},[_c('Breadcrumb',{attrs:{"currentPageName":_vm.title}}),_c('div',{staticClass:"wrapper"},[(_vm.loading)?_c('Spinner'):_c('div',{staticClass:"col-xl-8 mt-5 mb-5"},[_c('h5',{staticClass:"text-center"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{staticClass:"mt-5",domProps:{"innerHTML":_vm._s(_vm.body)}})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }